import React, { Component } from 'react';
import { Jumbotron } from 'reactstrap'
import  Navigation from '../Navigation/Navigation'
import { connect } from 'react-redux';
import './Dashboard.css';

class Dashboard extends Component {

    state = {  }
    render() { 
        return (
            <Navigation history={this.props.history}>
            <div className="welcome" >
                <Jumbotron className="shadow">
                    <h1 className="display-3">Bem-vindo(a)!</h1>
                    <p className="lead">Utilize os menus acima para navegar pela aplicação e realizar os cadastros e/ou alterações.</p>
                    <hr className="my-2" />
                    <p>Qualquer dúvida, entre em contato com a equipe de desenvolvimento.</p>
                </Jumbotron>
            </div>
            </Navigation>
          );
    }
}
 
const mapStateToProps = state => ({
   token: state.LoginReducer.token,
  
});

export default connect(mapStateToProps, {})(Dashboard);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Dashboard.js